import React from 'react'
import Quote from '../../quote'
import { withStyles } from '@material-ui/core/styles'

import styles from './styles'

const Quoter = withStyles(styles)(props => {
  const { contents, type, inc, count, classes } = props
  const data = contents.filter(x => x.type === type)[count[type]].content
  inc(type)
  return (
    data && (
      <div className={classes.margins}>
        <Quote
          quote={{
            quote: data.primary.quote,
            author: data.primary.author,
            company: data.primary.company,
          }}
        />
      </div>
    )
  )
})

export default withStyles(styles)(Quoter)



// WEBPACK FOOTER //
// ./src/components/scaffolding/widgets/quoter.js